// components/InstitutePlans.js
import React, { useState, useEffect } from 'react';
import './institute-Plans.css';
import Timer from './Timer'; // Timer component to show countdown
import Breadcrumb from '../Breadcrumb';
import Loading from '../../PrivacyPolicy/Loading';
import PlanLoading from './PlanLoading';

const InstitutePlans = () => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://e-training.ivorytraining.com/api/ar/institute-Plans');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        // Ensure the 'course' array exists before setting it
        if (data.data && data.data.course && data.data.course.length > 0) {
          setCourses(data.data.course); // Set courses only if there's data
          setStartDate(data.data.start_date); // Set the start date for the plan
          setEndDate(data.data.end_date); // Set the end date for the plan
        } else {
          setCourses([]);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []); // Empty dependency array to avoid infinite loop

  if (loading) {
    return <div className="container p-2 mt-4 fs-4"><Loading /></div>;
  }

  if (error) {
    return <div className="container">{error}</div>;
  }

  return (
    <>
      <Breadcrumb pages={["خطة المعهد"]} />
      <div className="container">
        {/* Show the timer only if start_date and end_date exist */}
        {startDate && endDate && (
          <div>
            <Timer startDate={startDate} endDate={endDate} />
          </div>
        )}

        {/* Display Plan Start Date and End Date */}
        <div className="plan-dates">
          {/* <h3>خطة المعهد: {startDate} - {endDate}</h3> */}
        </div>

        <div className="courseplan-part row justify-content-between" style={{ margin: '100px 0 40px 0' }}>
          {courses.length > 0 ? (
            courses.map((course) => (
              <div key={course.id} className="col-md-5" style={{ marginBottom: "40px" }}>
                <PlanLoading course={course} />
              </div>
            ))
          ) : (
            <div className="flex justify-center items-center h-full w-full text-xl">
              <p id="err">نأسف، لا يوجد دورات بهذه الاختيارات.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default InstitutePlans;
